<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="400"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar :color="$t('Customer.SelectAddressTypeDialog.Toolbar.Color')">
            <v-icon dark>
              {{ $t('Customer.SelectAddressTypeDialog.Toolbar.Icon') }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Customer.SelectAddressTypeDialog.Toolbar.Title') }}
            </div>
            <div class="text-caption">
              {{ $t('Customer.SelectAddressTypeDialog.Toolbar.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-2">
          <v-container
            class="pa-1"
            fluid
          >
            <v-row>
              <v-col cols="12">
                <v-list
                  class="pa-0"
                  two-line
                >
                  <template v-for="(item, index) in addressTypes">
                    <v-list-item
                      :key="`address-type-${item.Id}-${index}`"
                      :class="$vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-4'"
                      class="rounded"
                      ripple
                      @click="setAddressType(item)"
                    >
                      <v-list-item-avatar color="grey">
                        <v-icon>{{ item.Icon }}</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="text-left font-weight-bold">
                          {{ item.Name }}
                        </v-list-item-title>

                        <v-list-item-subtitle class="caption grey--text">
                          {{ item.Desc }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider :key="`address-type-divider-${item.Id}-${index}`" />
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            text
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DialogVisible from '@/mixins/dialogVisible.js'

export default {
  name      : 'SelectAddressTypeDialog',
  components: {},
  mixins    : [DialogVisible],
  props     : {},
  DataStore : {},
  data() {
    return {}
  },
  computed: {
    addressTypes() {
      const addressTypes = this.$t('Settings.Delivery.ListView.AddressType.Items') ?? []
      return addressTypes?.filter(addressType => this.appAddressTypes.includes(addressType.Id)) || []
    }
  },
  methods: {
    setAddressType(addressType) {
      if (!addressType) return

      this.onCancelButtonClick()
      this.$emit('save', addressType)
    },

    onCancelButtonClick() {
      this.closeDialog()
    }
  }
}
</script>
